module.exports =
  base: '/manager/v2'

  alpha:
    detail: '/manager/v2/alpha/detail/:widgetUser/order/:orderId'
    list: '/manager/v2/alpha/list/:widgetUser'
    deco:
      detail: '/manager/v2/alpha/deco/detail/order/:orderId'
      list: '/manager/v2/alpha/deco/list'

  order:
    base: '/manager/v2/orders'
    drafts: '/manager/v2/orders/drafts'
    detail: '/manager/v2/orders/:orderId'
    approval: '/manager/v2/orders/:orderId/approval'
    confirmed: '/manager/v2/orders/:orderId/confirmed'
    bypassApproval: '/manager/v2/orders/:orderId/bypassApproval'
    shipment: '/manager/v2/orders/:orderId/shipping-form/:shippingFormId'
    claim: '/manager/v2/orders/:orderId/claim'
    placeCsv: '/manager/v2/placeCsv'

  claim:
    base: '/manager/v2/claims'
    detail: '/manager/v2/claims/:claimId'

  settings:
    account: '/manager/v2/settings/account'
    api: '/manager/v2/settings/api'
    general: '/manager/v2/settings/general'
    subaccounts: '/manager/v2/settings/teams'

  design:
    base: '/manager/v2/designs'
    artwork: '/manager/v2/designs/artworks'
    generator: '/manager/v2/designs/generator/embr'

    # item:
    #   base: '/manager/v2/order/:orderId/item/:itemId/'
    #   artwork: '/manager/v2/order/:orderId/item/:itemId/artwork'

  printable:
    base: '/manager/v2/printables'
    mask: '/manager/v2/printables/mask'

  billing:
    base: '/manager/v2/billing'
    balance: '/manager/v2/billing/:billingId/balance'
    invoice: '/manager/v2/billing/:billingId/invoice/:invoiceId'
    invoices: '/manager/v2/billing/:billingId/invoices'
    invoiceStatement: '/manager/v2/billing/:billingId/invoiceStatement/:invoiceId'
    transactions: '/manager/v2/billing/:billingId/transactions'
    statement: '/manager/v2/billing/:billingId/statement'
    paymentMethods: '/manager/v2/billing/:billingId/paymentMethods'

  ecommerce:
    base: '/manager/v2/ecommerce'

  catalog:
    base: '/manager/v2/catalog'

  data:
    billing:
      withdraw: '/manager/v2/data/billing/:billingId/invoice/:invoiceId/withdraw'
      withdrawBreakdown: '/manager/v2/data/billing/:billingId/invoice/:invoiceId/withdrawBreakdown'
      invoiceDetails: '/manager/v2/data/billing/:billingId/invoice/:invoiceId/invoiceDetails'
      invoicesOutstanding: '/manager/v2/data/billing/:billingId/invoicesOutstanding'
      invoicesBulk: '/manager/v2/data/billing/:billingId/invoicesBulk'
      invoicesCsv: '/manager/v2/data/billing/:billingId/invoicesCsv'
      invoicesByPo: '/manager/v2/data/billing/:billingId/invoicePo'
      invoiceStatement:
        base: '/manager/v2/data/billing/:billingId/invoiceStatement'
        bulk: '/manager/v2/data/billing/:billingId/invoiceStatement/bulk'
      storeCredits: '/manager/v2/billing/:billingId/storeCredits'
      creditLineApplication: '/manager/v2/billing/:billingId/creditLineApplication'
      payment:
        base: '/manager/v2/data/billing/:billingId/payment'
        ach:   '/manager/v2/data/billing/:billingId/payment/ach'
        paypal: '/manager/v2/data/billing/:billingId/payment/paypal'
        store: '/manager/v2/data/billing/:billingId/payment/store'
      paypal:
        setup: '/manager/v2/data/billing/:billingId/payment/paypal/setup'
        details: '/manager/v2/data/billing/:billingId/payment/paypal/details'
      ach:
        base: '/manager/v2/data/billing/:billingId/ach'
        setup: '/manager/v2/data/billing/:billingId/ach/setup'
        verify: '/manager/v2/data/billing/:billingId/ach/verify'
        delete: '/manager/v2/data/billing/:billingId/ach/delete'
      paymentMethods:
        base: '/manager/v2/data/billing/:billingId/paymentMethods'
        create: '/manager/v2/data/billing/:billingId/paymentMethods/create'
        update: '/manager/v2/data/billing/:billingId/paymentMethods/update'
        delete: '/manager/v2/data/billing/:billingId/paymentMethods/delete'
      transactions:
        history: '/manager/v2/data/billing/:billingId/transactions/history'
        historyCsv: '/manager/v2/data/billing/:billingId/transactions/historyCsv'
        debits: '/manager/v2/data/billing/:billingId/transactions/debits'
        credits: '/manager/v2/data/billing/:billingId/transactions/credits'
        storeCredits: '/manager/v2/data/billing/:billingId/transactions/storeCredits'
      cashback:
        breakdown: '/manager/v2/data/billing/:billingId/cashback/breakdown'

    order:
      base: '/manager/v2/data/order'
      csv: '/manager/v2/data/order/csv'
      trackingCsv: '/manager/v2/data/:orderId/tracking/csv'
      placeCsv: '/manager/v2/data/order/placeCsv'
      placeOrder: '/manager/v2/data/order/placeOrder'
      overview: '/manager/v2/data/order/overview'
      counts: '/manager/v2/data/order/counts'
      bulk: '/manager/v2/data/order/bulk'
      detail: '/manager/v2/data/order/:orderId'
      approve: '/manager/v2/data/order/:orderId/approve'
      change: '/manager/v2/data/order/:orderId/change'
      address: '/manager/v2/data/order/:orderId/address'
      addressValidate: '/manager/v2/data/order/:orderId/addressValidate'
      shippingPrices: '/manager/v2/data/order/:orderId/shipping-prices'
      shippingMethod: '/manager/v2/data/order/:orderId/shipping-method'
      shippingFormParts: '/manager/v2/data/order/:orderId/shippingFormParts/:shippingFormId'
      alpha:
        list: '/manager/v2/data/order/alpha/list'
      onHold:
        address: '/manager/v2/data/order/onHold/address'
        ip: '/manager/v2/data/order/onHold/ip'

    claim:
      base: '/manager/v2/data/claim'
      csv: '/manager/v2/data/claim/csv'

    user:
      detail: '/manager/v2/data/users/:userId'

    employee:
      arRep: '/manager/v2/data/employee/:employeeId/arRep'

    cart:
      base: '/manager/v2/data/carts'
      detail: '/manager/v2/data/carts/:cartId'

    artwork:
      base: '/manager/v2/data/artwork'
      bulk: '/manager/v2/data/artwork/bulk'

    design:
      base: '/manager/v2/data/designs'
      bulk: '/manager/v2/data/designs/bulk'
      editName: '/manager/v2/data/designs/:designId/editName'

    printable:
      base: '/manager/v2/data/printables'
      csv: '/manager/v2/data/printables/csv'
      editName: '/manager/v2/data/printables/:printableId/editName'
      bulk: '/manager/v2/data/printables/bulk'
      group:
        base: '/manager/v2/data/printables/group'
        editName: '/manager/v2/data/printables/group/:printableGroupId/editName'
        editPrintables: '/manager/v2/data/printables/group/:printableGroupId/editPrintables'

    pricing:
      base: '/manager/v2/data/pricing'
      bulk: '/manager/v2/data/pricing/bulk'

    approval:
      order:
        base: '/manager/v2/data/approval/order'
        changeDesign: '/manager/v2/data/approval/order/changeDesign'
        uploadRights: '/manager/v2/data/approval/order/uploadRights'
      artwork:
        base: '/manager/v2/data/approval/artwork'
      artworkApproval:
        base: '/manager/v2/data/approval/artworkApproval'
        bulk: '/manager/v2/data/approval/artworkApproval/bulk'
      artworkConversion:
        base: '/manager/v2/data/approval/artworkConversion'
        bulk: '/manager/v2/data/approval/artworkConversion/bulk'

    event:
      base: '/manager/v2/data/order/:orderId/events'

    shippingForm:
      detail: '/manager/v2/data/shipping-forms/:shippingFormId'
      bulk: '/manager/v2/data/shipping-forms/bulk'
      prices: '/manager/v2/data/shipping-forms/:shippingFormId/prices'
      byOrderId: '/manager/v2/data/shipping-forms/:shippingFormId/byOrderId'

    productItem:
      bulk: '/manager/v2/data/product-items/bulk'
      gtin: '/manager/v2/data/product-items/gtin/:gtin'
      bestPrices: '/manager/v2/data/product-items/bestPrices'
      priceMap: '/manager/v2/data/product-items/priceMap'

    externalBlankOrder:
      detail: '/manager/v2/data/externalBlankOrder/:externalBlankOrderId/detail'
      bulk: '/manager/v2/data/externalBlankOrder/bulk'



// WEBPACK FOOTER //
// ./~/oo-routes/routes/manager2.coffee